<template>
  <span
    v-tooltip="tooltipData"
    :class="severityClass"
    data-cy="validation-errors"
  >
    <slot />
  </span>
</template>

<script setup lang="ts">
import { scenarioValidatorKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import type { ValidationTestName } from "@/composables/validation/validationTestName";
// import type { UseScenarioValidator } from "@/composables/validation/scenarioValidator";
// import { useStackValidator } from "@/composables/scenarioDetailProvider/useStackValidator";
// import { useHasDualStacks } from "@/composables/scenarioDetailProvider/stackFiltering";
import { injectStrict } from "@/utils/utils";
import { computed } from "vue";
import type { StackLocation } from "./equipment/d";

const props = defineProps<{
  ruleNames: ValidationTestName[];
  xrefId?: string;
  stack?: StackLocation;
}>();

// const equipment = injectStrict(equipmentKey);
// const hasDualStacks = useHasDualStacks(equipment);

const { filterByXrefIdAndRuleNames } = injectStrict(scenarioValidatorKey);
const errors = filterByXrefIdAndRuleNames(props.ruleNames, props.xrefId);
// Use stack-aware validator when dual stacks are enabled and stack prop is provided
// const stackValidator = computed(() => {
//   if (
//     hasDualStacks.value &&
//     props.stack &&
//     (props.stack === "upper" || props.stack === "lower")
//   ) {
//     return useStackValidator(props.stack) as UseScenarioValidator;
//   }
//   return null;
// });

// // Use legacy validator when dual stacks are not enabled or stack prop is not provided
// const legacyValidator = computed(() => {
//   if (!hasDualStacks.value || !props.stack) {
//     return injectStrict(scenarioValidatorKey);
//   }
//   return null;
// });

// // Get the appropriate validator - guaranteed to have a value
// const validator = computed(() => {
//   return stackValidator.value || legacyValidator.value;
// });

// const errors = computed(() => {
//   const v = validator.value;
//   if (!v) {
//     return [];
//   }
//   return v.filterByXrefIdAndRuleNames(props.ruleNames, props.xrefId).value;
// });

const severityLevels = ["success", "info", "warn", "error", "catastrophe"];
// const severityClass = computed(() => {
//   if (!errors?.value || errors.value.length === 0) {
//     return severityLevels[0]; // success
//   }
//   return severityLevels[Math.max(...errors.value.map(err => err.severity))];
// });
const severityClass = computed(
  () => severityLevels[Math.max(...errors?.value.map(err => err?.severity))]
);
const tooltipData = computed(() => ({
  value:
    errors?.value[0]?.message +
    (errors?.value.length > 1
      ? ` and ${errors?.value.length - 1} more...`
      : ""),
  disabled: !errors?.value[0],
  class: severityClass.value
}));
</script>

<style scoped lang="scss">
// Add in extra styles that pertain
// to what this component is wrapping

:deep(.warn) {
  color: var(--warning-500);

  .p-checkbox-box {
    border-color: var(--warning-500);
  }
}
:deep(.error) {
  color: var(--danger-500);

  .p-checkbox-box {
    border-color: var(--danger-500);
  }
}
</style>
